import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { makeSpine } from "html-living-framework/lib/Utils/PixiUtils";
import {Ease} from "../core/Animatable";
import {IPoint, PointUtil} from "../core/Geom";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {AbstractCharacter} from "./AbstractCharacter";
import {TrashItem} from "./TrashItem";
import { TrashItemCollect } from "./TrashItemCollect";
import { TrashItemReturn } from "./TrashItemReturn";

export class Abby extends AbstractCharacter {

    public readonly spine = this.addChild(makeSpine("abby-profile"));

    protected animations = {
        BLINK: "blink",
        IDLE: "idle",
        LIP_FLAP: "lip-flap",
        WALK: "walk",
        WAVE: "wave",
        WAND: "wand-flourish",
        SMILE: "easter-egg-reaction",
    };

    constructor() {
        super("abby");
    }

    public Wand() {
        this.spine.state.setAnimation(this.tracks.ARMS, this.animations.WAND, false);
    }

    public Smile() {
        if (this.spine.state.getCurrent(this.tracks.HEAD)?.animation?.name !== this.animations.SMILE) {
            this.spine.state.setAnimation(this.tracks.HEAD, this.animations.SMILE, false);
            this.spine.state.addEmptyAnimation(this.tracks.HEAD, 0, 0);
        }
    }

    protected onAnimationComplete(pEntry: PIXI.spine.core.TrackEntry) {
        // intentionally not calling super.onAnimationComplete

        switch (pEntry.animation.name) {
            case this.animations.WAVE:
            case this.animations.WAND:
                this.spine.state.setEmptyAnimation(this.tracks.ARMS, 0.25);
                break;
        }
    }

}
